export var PersistentDownloadFileAccessMode;
(function (PersistentDownloadFileAccessMode) {
    PersistentDownloadFileAccessMode["AUTHENTICATED_CREATOR"] = "authenticated_creator";
    PersistentDownloadFileAccessMode["AUTHENTICATED_PROJECT"] = "authenticated_project";
    PersistentDownloadFileAccessMode["SIGNED"] = "signed";
    PersistentDownloadFileAccessMode["LEGACY_PUBLIC"] = "legacy_public";
})(PersistentDownloadFileAccessMode || (PersistentDownloadFileAccessMode = {}));
//# sourceMappingURL=persistentDownloadFile.js.map